import NewsVideo from './NewsVideo';
export default NewsVideo;
